/**
 * Set of field names that should be excluded from GraphQL fragment generation.
 */
export const FRAGMENT_FIELD_DENY_SET: Set<string> = new Set<string>(['allAncestors']);

/**
 * Configuration for field-type-based edge cases that violate default rules.
 */
export type EdgeCaseTypeSelectionConfig = {
	selection: string;
};

export const EDGE_CASE_TYPE_SELECTIONS: Record<string, EdgeCaseTypeSelectionConfig> = {
	ConfluencePageLinks: {
		selection: 'webUi\nbase',
	},
	ConfluenceWhiteboardLinks: {
		selection: 'webUi\nbase',
	},
	ConfluenceSpaceLinks: {
		selection: 'webUi\nbase',
	},
	ConfluenceCommentLinks: {
		selection: 'webUi\nbase',
	},
	ConfluenceBlogPostLinks: {
		selection: 'webUi\nbase',
	},
	ConfluenceDatabaseLinks: {
		selection: 'webUi\nbase',
	},
	ConfluenceEmbedLinks: {
		selection: 'webUi\nbase',
	},
	ConfluenceFolderLinks: {
		selection: 'webUi\nbase',
	},
};
